exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.container {\n  height: 100%;\n}\n#app {\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n  overflow: auto;\n  /* 滚动槽 */\n}\n#app::-webkit-scrollbar {\n  display: none; /* Chrome Safari */\n}\n", "", {"version":3,"sources":["/home/jenkins/agent/workspace/n1pay-system-manager-merchant/src/components/home/home.vue"],"names":[],"mappings":";AACA;EACE,aAAa;CACd;AACD;EACE,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,SAAS;CACV;AACD;EACE,cAAc,CAAC,mBAAmB;CACnC","file":"home.vue","sourcesContent":["\n.container {\n  height: 100%;\n}\n#app {\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n  overflow: auto;\n  /* 滚动槽 */\n}\n#app::-webkit-scrollbar {\n  display: none; /* Chrome Safari */\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9f9b2524","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/home/home.vue
// module id = 5JOJ
// module chunks = 18